export function doesStringStartWithEmoji(str: string): boolean {
  const emojiRegex = /^(?!\d)\p{Emoji}/u;
  return emojiRegex.test(str);
}

export function doesStringStartWithEnglishOrDigit(str: string): boolean {
  const englishRegex = /^[A-Za-z0-9]/;
  return englishRegex.test(str);
}
